import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDeviceType } from "@/reducers/deviceSlice";

const BREAKPOINT_TABLET = 768;
const BREAKPOINT_DESKTOP = 1024;

const getDeviceType = () => {
  const width = window.innerWidth;
  if (width >= BREAKPOINT_DESKTOP) return "desktop";
  if (width >= BREAKPOINT_TABLET) return "tablet";
  return "mobile";
};

const useDeviceType = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const update = () => {
      const type = getDeviceType();

      document.body.classList.remove(
        "viewtype-desktop",
        "viewtype-tablet",
        "viewtype-mobile"
      );
      document.body.classList.add(`viewtype-${type}`);

      dispatch(setDeviceType({ deviceType: type }));
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [dispatch]);

  return null;
};

export default useDeviceType;
